module.exports = __webpack_public_path__ + "static/media/корридор гг 3.961f072e.jpg";